
    <div class="d-flex d-flex-gap-2x flex-column">
      <div fieldmagicGridRow>
        <div
          fieldmagicGridColumn="12"
          class="d-flex d-flex-gap justify-content-between align-items-center"
        >
          <div class="d-flex d-flex-gap w-50 align-items-center">
            <fieldmagic-dropdown-input
              class="w-50"
              [(ngModel)]="variant"
              [options]="variants$ | async"
              [standalone]="false"
              (ngModelChange)="onVariantChange($event)"
              placeholder="Select a variant.."
              label="Variant"
            >
            </fieldmagic-dropdown-input>

            <fieldmagic-dropdown-input
              class="w-50"
              [(ngModel)]="checklist"
              [options]="checklists$ | async"
              [standalone]="false"
              (ngModelChange)="onChecklistChanged()"
              placeholder="Select a checklist.."
              label="Checklist"
              [clearable]="false"
            >
            </fieldmagic-dropdown-input>
          </div>
          <div class="d-flex d-flex-gap w-35 align-items-center">
            <fieldmagic-primary-button
              variant="link"
              [icon]="[{
                icon: 'plus-circle',
                klass: 'text-success'
              }]"
              (click)="onAddChecklist()"
              label="Add Checklist"
            >
            </fieldmagic-primary-button>

            <convert-pdf-with-ai-button
              (uploaded)="onGenerate($event)"
              [moduleOrigin]="'checklist'"
              [purpose]="'pdf_checklist_ai'"
              [data]="{
                'checklist_type': 'asset',
                'mode': mode$ | async,
                'specifics': specifics,
                'asset_type_name': assetTypeName,
                'force_preview': true
              }"
            >
            </convert-pdf-with-ai-button>

            <checklists-generate-with-ai-button
              [data]="{
                'checklist_type': 'asset',
                'mode': mode$ | async,
                'specifics': specifics,
                'asset_type_name': assetTypeName,
                'force_preview': true
              }"
              (generated)="onGenerate($event)"
            >
            </checklists-generate-with-ai-button>
          </div>
        </div>

        <div
          *ngIf="fetching$ | async"
          fieldmagicGridColumn="12"
          class="d-flex justify-content-center"
        >
          <fieldmagic-icon [spin]="true"></fieldmagic-icon>
        </div>

        <div
          *ngIf="! (fetching$ | async)"
          fieldmagicGridColumn="12"
          class="d-flex justify-content-center"
        >
          <fieldmagic-text [content]="error$ | async"></fieldmagic-text>
        </div>

        <ng-container *ngIf="(! (fetching$ | async)) && (error$ | async | blank)">
          <div
            *ngIf="checklist$ | async as checklist"
            fieldmagicGridColumn="12"
          >
            <app-update-checklist
              [asInput]="true"
              [checklist]="checklist"
              [assetType]="assetType$ | async"
              (changed)="onInputChange($event)"
            >
            </app-update-checklist>
          </div>
        </ng-container>
      </div>
    </div>
  